import { Component, inject, NO_ERRORS_SCHEMA, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ITab, TabsComponent, TileComponent } from '@tecalisdev/infinity';
import { RejectionReasonsComponent } from '../rejection-reasons/rejection-reasons.component';
import { TopNationalitiesComponent } from '../top-nationalities/top-nationalities.component';

type PanelInsightTabId = 'rejection_reasons' | 'nationalities';

@Component({
	selector: 'app-panel-insights',
	imports: [TileComponent, TabsComponent, RejectionReasonsComponent, TopNationalitiesComponent],
	templateUrl: './panel-insights.component.html',
	styleUrl: './panel-insights.component.scss',
	schemas: [NO_ERRORS_SCHEMA],
})
export class PanelInsightsComponent {
	private trans = inject(TranslateService);

	public readonly selectedTabId = signal<PanelInsightTabId>('rejection_reasons');

	public readonly tabs = signal<ITab[]>(this.buildTabs('rejection_reasons'));

	public onTabSelected(tab: { id: string; label: string }): void {
		const id = tab.id as PanelInsightTabId;
		if (id !== 'rejection_reasons' && id !== 'nationalities') {
			return;
		}
		this.selectedTabId.set(id);
		this.tabs.set(this.buildTabs(id));
	}

	private buildTabs(selected: PanelInsightTabId): ITab[] {
		return [
			{
				id: 'rejection_reasons',
				label: this.trans.instant('PANEL.REJECTION_REASONS.TAB'),
				selected: selected === 'rejection_reasons',
			},
			{
				id: 'nationalities',
				label: this.trans.instant('PANEL.REJECTION_REASONS.TAB_NATIONALITIES'),
				selected: selected === 'nationalities',
			},
		];
	}
}
